<template>
  <ul
    class="list-disc text-[15px] leading-6 text-gpx_black-400 marker:text-[32px] marker:text-gpx_slate-900"
  >
    <slot />
  </ul>
</template>

<script setup></script>
